import AgentList from './AgentList';

export default AgentList;
